import {
  Box,
  Button,
  ButtonGroup,
  Center,
  Divider,
  HStack,
  Stack,
  Text,
  useColorModeValue,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import React from "react";
import { Light as SyntaxHighlighter } from "react-syntax-highlighter";
import sql from "react-syntax-highlighter/dist/esm/languages/hljs/sql";
import a11yDark from "react-syntax-highlighter/dist/esm/styles/hljs/a11y-dark";
import a11yLight from "react-syntax-highlighter/dist/esm/styles/hljs/a11y-light";

import { Status } from "../../components/shared/Status";
import ENCRYPT_COLS_JSON from "./ExchangeColumns.json";

import { Module } from "../../assets/wasm/encrypt_wasm_fixed.mjs";
import { ISelectOption } from "../../components/forms/SelectControl";
import { LibFullWidthSpinner } from "../../components/lib";
import { MaterialIcon } from "../../components/shared/MaterialIcon";
import { EditQueryModal } from "../encrypt/EditQueryModal";
import { EncryptTable } from "../encrypt/EncryptTable";
import { env } from "process";
import { Link } from "react-router-dom";

const ENCRYPT_AWS_URL = "https://apihme1.geneial.com:8081/query";
const ENCRYPT_AWS_AES_URL = "https://apihme1.geneial.com:8082/aes_results";


var ENCRYPT_URL = ENCRYPT_AWS_URL;
var ENCRYPT_AES_URL = ENCRYPT_AWS_AES_URL;

// Get the index of the filed used in the JSON file (also it's the DB index)
function getQueryFieldIndex(qry) {
  // current_field_index

  for (const [key, value] of Object.entries(ENCRYPT_COLS_JSON)) {
    if (RegExp('\\b' + key + '\\b').test(qry) === true) {
      console.log("index for " + key + " is " + (parseInt(value.column_number) - 1));
      return (parseInt(value.column_number) - 1);
    }
  }

  console.log("column not found in query!");

  return -1;
}

const query = (Params : any) => {
  (async () => {

    const rawResultResponse = await fetch(ENCRYPT_URL, {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body:
      Params.status === 1 ? Params.wasm.FHEEncryptQuery(Params.qry, getQueryFieldIndex(Params.qry)) : '{"action":"getNextResult","currentMatches":"' + Params.numMatches + '"}', //<— returns valid JSON to send
    });


    var rawResultContent = "";
    try {
      rawResultContent = await rawResultResponse.text(); // get json returned encrypted rows and info
    } catch (e: any) {
      console.log(".text() Error: " + e.message);
    }


    var sub = rawResultContent.substring(0, 4);

    if (sub === "done") {
      Params.loadData(); // refresh the UI table to include any lagging updates
      Params.setStatus(0); // Done searching the database...
      return;
    }

    var matched_row = -1;
    try {
      matched_row = Params.wasm.DecryptJsonResult(rawResultContent);
    } catch (e: any) {
      console.log("eeeee", e);
      console.log(
        "encres() Error: " + e + " name:" + e.name + " msg:" + e.message
      );
    }


    if (matched_row !== -1) {

      Params.setNumMatches((prevState) => prevState + 1);

      // fetch this row of AES data and decrypt it... aes_row_index
      const rawAESResponse = await fetch(ENCRYPT_AES_URL, {
        method: "POST",
        mode: "cors",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: '{"aes_row_index":"' + matched_row + '"}',
      });


      const aescontent = await rawAESResponse.text();


      var clearTextContent = "";
      try {
        clearTextContent = Params.wasm.AESDecodeAndDecrypt(aescontent);
      }
      catch (e) {
        console.log("AES decode/Decrypt ERROR");
        console.log("Error: " + e);
      }


      var clearJson = {};
      try {
        // parse decoded and decrypted plaintext data as a json array
        clearJson = await JSON.parse(clearTextContent);

        const listRowFields: string[] = clearJson["row"];

        Params.setResults_ary((prevState) => {

          if (prevState && prevState.length) {
            return [...prevState, listRowFields];
          }

          return [listRowFields];
        });

      } catch (e) {
        console.log("JSON PARSE ERROR");
        console.log("Error: " + e);
      }

      Params.loadData(); // refresh the UI table now that a new match has been made

    } else {
      // no match...
    }

    // are we done? or checking the next row in the DB?
    Params.setStatus((prevState) => prevState + 1);

  })();
};

const ExternalSearchQuery = () => {
  const [queryData, setQueryData] = React.useState<{ [key: string]: string }[]>(
    []);

  const [requestAccessClicked, setRequestAccessClicked] = React.useState(false);


  const [queryRun, setQueryRun] = React.useState(false);
  //const [requestSent, setRequestSent] = React.useState(false);

  const [wasmModule, setWasmModule] = React.useState<any>(null);

  const [sqlStatement, setSqlStatement] = React.useState<string>(
    "SELECT * from TABLE WHERE AGE > 2.5 AND YEAR = 2020;"
  );
  const [results_ary, setResults_ary] = React.useState([]);
  const [status, setStatus] = React.useState(0); // default to zero (do nothing)
  const [numMatches, setNumMatches] = React.useState(0);
  const [current_row, setCurrent_row] = React.useState(0);
  const [columns, setColumns] = React.useState<ISelectOption[]>([]);

  const syntaxStyle = useColorModeValue(a11yLight, a11yDark);
  const syntaxBgStyle = useColorModeValue("white", "#2b2b2b");

  const toast = useToast();

  const {
    isOpen: isOpenEditQueryModal,
    onOpen: onOpenEditQueryModal,
    onClose: onCloseEditQueryModal,
  } = useDisclosure();

  const handleRequestAccessClick = () => {
    setRequestAccessClicked(true);
  };

  const handleOnQuery = async () => {

    setResults_ary([]); // reset table in case this is not the first run...

    // Flip the switch to start query
    if (status > 0) {
      toast({
        title: "Query in progress...",
        description: ``,
        status: "loading",
        variant: "subtle",
        isClosable: true,
      });
      return;
    }

    if (sqlStatement) {
      setStatus(1);
      toast({
        title: "Running Query...",
        description: ``,
        status: "loading",
        variant: "subtle",
        isClosable: true,
      });
      //   try {
      //     // Post data to api
      //   } catch (err) {
      //     console.error("Query Failed", err);
      //     toast({
      //       title: "Query failed",
      //       status: "error",
      //       variant: "subtle",
      //       isClosable: true,
      //     });

      //     // Throw error for downstream form to handle
      //     throw err;
      //   }
    }

    setQueryRun(true);
  };

  const zipRows = (rows: [string[]]) => {
    const data = rows.map((row) => {
      const dataRowObj: { [key: string]: string } = {};

      row.forEach((fieldVal, fieldIdx) => {
        if (columns[fieldIdx]) {
          dataRowObj[columns[fieldIdx].value] = fieldVal;
        }
      });

      return dataRowObj;
    });

    setQueryData(data);
  };

  const loadData = () => {
    const loadData = results_ary as unknown as [string[]];
    zipRows(loadData);
  };

  const onReset = () => {
    setQueryData([]);
    setResults_ary([]);
  };

  const onChangeQuery = (querySql: string) => {
    setQueryData([]);
    setResults_ary([]);
    setSqlStatement(querySql);
  };



  React.useEffect(() => {
    try {
      Module().then((result) => {
        setWasmModule(result);
      });
    } catch (e) {
      toast({
        title: "Encrypt Error",
        description: "Encrypt failed to load",
        status: "error",
        duration: 2000,
        isClosable: true,
      });
    }
  }, []);

  React.useEffect(() => {
    const columnsUpdate: ISelectOption[] = [];

    for (const [key, value] of Object.entries(ENCRYPT_COLS_JSON)) {
      columnsUpdate.push({
        value: key,
        label: key,
      });
    }

    setColumns(columnsUpdate);
  }, []);

  React.useEffect(() => {

    //console.log(results_ary);
  }, [results_ary]);

  React.useEffect(() => {
    // console.log("in status useEffect... status is " + status);

    var Params = {};

    // start querying DB rows?
    if (status === 1) {

      // reset matches to zero
      setNumMatches(0);

      // start first query
      // run the first query (it will set the status to getNextRow or Done)
      Params = {
        wasm : wasmModule,
        setResults_ary : setResults_ary,
        status: 1,
        numMatches : numMatches,
        current_row : 0,
        setStatus : setStatus,
        setNumMatches : setNumMatches,
        sqlStatement : sqlStatement,
        loadData : loadData
      };

      query(Params);
    } else if (status > 1) {
      // if not zero and not 1 then get the next row

      var row_num = current_row + 1;

      setCurrent_row((prevState) => prevState + 1);

      // run another query
      Params = {
        wasm : wasmModule,
        setResults_ary : setResults_ary,
        status: status,
        numMatches : numMatches,
        current_row : row_num,
        setStatus : setStatus,
        setNumMatches : setNumMatches,
        sqlStatement : sqlStatement,
        loadData : loadData
      };

      query(Params);
    }
  }, [status]);

  return (
    <>
      <Box h="full">
        <Stack spacing={12}>
          <Stack
            justify={"space-between"}
            borderWidth={1}
            divider={<Divider />}
            spacing={0}
          >
            <Stack bg={syntaxBgStyle} p={4} minH={48}>
              <Box>
                <HStack color="text.softer" px={2}>
                  <MaterialIcon
                    name={"enhanced_encryption"}
                    variant="outline"
                    fontSize=".75rem"
                  />
                  <Text>Geneial Exchange</Text>
                </HStack>
              </Box>

              <SyntaxHighlighter
                language={"sql"}
                wrapLines={true}
                wrapLongLines={true}
                style={{
                  ...syntaxStyle,
                  backgroundColor: "red",
                }}
              >
                {sqlStatement}
              </SyntaxHighlighter>
            </Stack>
            <Box p={4} bg="bg.high">
              <HStack alignItems="center" spacing={4}>
                <ButtonGroup spacing={4}>
                  <Button
                    // isLoading={isLoadingCreateRegistry}
                    loadingText="Running query"
                    onClick={handleOnQuery}
                    colorScheme={"primary"}
                    rightIcon={
                      <MaterialIcon name="play_arrow" fontSize={"1.25rem"} />
                    }
                  >
                    Run Query
                  </Button>
                  <Button onClick={onOpenEditQueryModal}>Edit Query</Button>
                </ButtonGroup>
                <Text>Checking Row: {status}</Text>
                {status > 0 && (
                  <LibFullWidthSpinner size="md" thickness="2px" />
                )}

              </HStack>
            </Box>

            {queryRun && (
              <Box p={4}>
                <div style={{ display: "flex", flexDirection: "column", fontSize: "1.2rem" }}>
                  <p style={{ color: "#1C4342" }}>
                    • The query has identified {queryData.length} participants within the Geneial network that fulfill the specified criteria.
                    <p style={{ color: "#1C4342" }}>
                      • To request data access, please press the button below:
                    </p>
                  </p>
                </div>
                <HStack spacing={6}>
                  <Button colorScheme="teal" size="lg" mr={1} onClick={handleRequestAccessClick}>
                    Request Access
                  </Button>
                  {requestAccessClicked && (
                    <>
                      <Link to="/view_all_requests_page">
                        <Button colorScheme="teal" size="lg">
                          View all Requests
                        </Button>
                      </Link>
                    </>
                  )}
                </HStack>
                {requestAccessClicked && (<Box p={4}>
                  <div style={{ display: "flex", flexDirection: "column", fontSize: "1.2rem" }}>
                    <p style={{ color: "#1C4342" }}>
                    • We have sent your request(s) to the registry participants.
                      For an overview of your submitted requests, their current status, and to cancel them before approval,
                      click on <strong>View all Requests</strong>.
                    </p>
                  </div>
                </Box>
                )}
              </Box>
            )}
          </Stack>
          <Stack
            justify={"space-between"}
            borderWidth={1}
            divider={<Divider />}
            spacing={0}
          >
            {queryData && queryData.length && (
              <HStack p={4} justify="space-between">
                <HStack>
                  <MaterialIcon
                    name="check"
                    color="success"
                    fontSize={"1.25rem"}
                  />

                  <Text fontWeight={"bold"}>{queryData.length} Rows</Text>
                </HStack>
                <Button onClick={onReset}>Reset Query</Button>
              </HStack>
            )}

            <Box>
              {(!queryData || !queryData.length) && (
                <Box>
                  <Center>
                    <Status.NoData
                      title="Nothing to Display"
                      description="Please run your query to view results"
                      iconColor="text.softer"
                    ></Status.NoData>
                  </Center>
                  {!queryRun && (
                    <Box p={4}>
                      <div style={{ display: "flex", flexDirection: "column", fontSize: "1.4rem" }}>
                        <p style={{ color: "#1C4342" }}>
                          • Click on <strong>Edit Query</strong> to define your desired search criteria.
                          Once you've set the parameters, proceed by clicking <strong>Run Query</strong> to initiate the search on the website.
                        </p>
                      </div>
                    </Box>
                  )}
                </Box>
              )}

              {queryData && queryData.length ? (
                <Box>
                  <EncryptTable columns={columns} data={queryData} />
                </Box>
              ) : null}
            </Box>
          </Stack>
        </Stack>
      </Box>

      <EditQueryModal
        isOpen={isOpenEditQueryModal}
        onChange={onChangeQuery}
        onClose={onCloseEditQueryModal}
        columns={columns}
      ></EditQueryModal>
    </>
  );
};

export default ExternalSearchQuery;

